import {LicenseInfo} from '@mui/x-data-grid-pro'
import {QueryClientProvider} from '@tanstack/react-query'
import {AuthProvider, setupAxios} from '_component/modules/auth'
import '_metronic/assets/sass/plugins.scss'
import '_metronic/assets/sass/style.react.scss'
import '_metronic/assets/sass/style.scss'
import {MetronicI18nProvider} from '_metronic/i18n/Metronici18n'
import {ThemeModeProvider} from '_metronic/partials/layout/theme-mode/ThemeModeProvider'
import axios from 'axios'
import {Chart, registerables} from 'chart.js'
import 'GLOBAL/envVariables'
import 'nouislider/dist/nouislider.css'
import {createRoot} from 'react-dom/client'
import {Provider} from 'react-redux'
import {PersistGate} from 'redux-persist/integration/react'
import store, {persistor} from 'redux/store'
import {AppRoutes} from 'routes/AppRoutes'
import {queryClient} from 'utils/reactQuery/queryClient'
import './index.css'

setupAxios(axios)
Chart.register(...registerables)

const muiKey: any = process.env.REACT_APP_MUI_KEY
LicenseInfo.setLicenseKey(muiKey)
const container = document.getElementById('root')
if (container) {
  createRoot(container).render(
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <QueryClientProvider client={queryClient}>
          <MetronicI18nProvider>
            <ThemeModeProvider>
              <AuthProvider>
                <AppRoutes />
              </AuthProvider>
            </ThemeModeProvider>
          </MetronicI18nProvider>
        </QueryClientProvider>
      </PersistGate>
    </Provider>
  )
}
